/** Public, sanitized documentation. Permissions for application data remain in the API. */
export const USER_MANUALS: Readonly<Record<string, string>> = {
  'TMS': '/assets/manuals/tms/index.html',
  'Test tracking': '/assets/manuals/test-tracking/index.html',
  'Authorization Requests': '/assets/manuals/authorization-requests/index.html',
  'Customer Services': '/assets/manuals/customer-services/index.html',
  'External Data': '/assets/manuals/masterdata/index.html'
};
